import { Params } from '@angular/router';

import { OriginCode } from '../business/kenobi/origin-code.enum';
import { Status } from '../business/kenobi/status.enum';

export class TrackingUtils {
    /**
     * Returns the src queryParam value if present
     * @param params
     */
    public static getSrcQueryParam(params: Params): OriginCode {
        const srcParamName = Object.keys(params).find((key) => /^src$/i.test(key));

        if (srcParamName && params[srcParamName]) {
            return <OriginCode>encodeURI(params[srcParamName]);
        }
    }

    /**
     * Gets Kenobi status from HTTP status
     * @param {number} httpStatus Technical HTTP status
     * @returns {Status}
     */
    public getKenobiStatusFromHttpStatus(httpStatus: number) {
        const httpStatusString: string = httpStatus.toString();
        let kenobiStatus: Status;

        if (httpStatusString.startsWith('4')) {
            kenobiStatus = Status.KORG;
        } else if (httpStatusString.startsWith('5')) {
            kenobiStatus = Status.KOSI;
        } else {
            kenobiStatus = Status.OK;
        }

        return kenobiStatus;
    }
}
